module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/minimal_0-af28c07058e833314a2be8d9769e9451.png";